<template>
  <div class="box">
    <OperationBoxComponent :actions="actions" />
    <CategoryListComponent :page-data="pageData" v-if="pageData.length > 0" :handle-remove="remove" @onSortChanged="this.reSort" @onCategoryListChanged="updateCategoryList" @onCategoryEdit="editCategory" />
    <el-dialog title="编辑分类" :visible.sync="showEditDialog" width="30%">
      <el-form :model="formData">
        <el-form-item label="分类名称" label-width="120px" :rules="[{ required: true, message: '排序不能为空'}]">
          <el-input v-model="formData.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序" label-width="120px" :rules="[{ required: true, message: '排序不能为空'}]">
          <el-input v-model="formData.sort" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="icon" label-width="120px" :rules="[{ required: true, message: 'icon不能为空'}]">
          <el-upload
            class="avatar-uploader"
            action="/mgr/image/upload"
            :data="{type:'icon'}"
            :multiple="false"
            :show-file-list="false"
            :on-success="handleUploadSuccess">
            <img v-if="formData.icon" :src="formData.icon" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditDialog = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OperationBoxComponent from '../../../components/common/OperationBoxComponent'
import {CategoryRequestUtil} from '../../../utils/CategoryRequestUtil'
import CategoryListComponent from '../../../components/category/CategoryListComponent'
export default {
  name: 'CategoryListPage',
  components: { CategoryListComponent, OperationBoxComponent },
  data () {
    return {
      actions: [
        { title: '', icon: 'el-icon-refresh', type: 'button', theme: 'primary', action: this.updateCategoryList },
        { title: '添加', type: 'button', theme: 'success', action: this.editCategory }
      ],
      pageData: [],
      formData: {id: 0, title: '', sort: 100, icon: ''},
      showEditDialog: false,
      queryParam: {
        page: 1,
        pageSize: 25
      }
    }
  },
  mounted () {
    this.updateCategoryList()
  },
  methods: {
    editCategory (data) {
      this.showEditDialog = true
      if (data.id) {
        this.formData = data
      } else {
        this.formData = {id: 0, title: '', sort: 100, icon: ''}
      }
    },
    save () {
      let that = this
      CategoryRequestUtil.save(this.formData, function (response) {
        if (response.id) {
          that.updateCategoryList()
          that.showEditDialog = false
        }
      })
    },
    remove (id) {
      let that = this
      CategoryRequestUtil.remove(id, () => { that.updateCategoryList() })
    },
    updateCategoryList () {
      let that = this
      this.pageData = []
      CategoryRequestUtil.queryCategoryList({queryParam: this.queryParam}, function (response) {
        if (response) {
          that.pageData = response
        }
      })
    },
    reSort (param) {
      let that = this
      CategoryRequestUtil.updateSort(param, function () { that.updateCategoryList() })
    },
    handleUploadSuccess (response) {
      if (response.result === 0) {
        this.formData.icon = response.data.url
      }
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.avatar {
  width: 60px;
  height: 60px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/whaledge/category/CategoryListPage.vue